<template>
<b-container class="reset-password-container" v-if="user != null && loaded">
	<div class="login-form-wrapper">
		<branding-heading></branding-heading>

<b-row v-show="submissionStatus == 'submission-success'">
	<b-col>
		<h1>Your account has been updated.</h1>
		<p>Proceed to log into Winnipeg Lane Closures</p>
		<b-button @click="goToHome" variant="primary">Log In</b-button>
	</b-col>
</b-row>
<b-form @submit="onSubmit" @reset="onReset" v-show="submissionStatus != 'submission-success'">
	<h1>Set Your Password</h1>
	<b-row>
		<b-col lg="4">
			<p>Your Username is <strong>{{user.username.value}}</strong></p>

			<b-form-group label="Enter New Password"
				:state="user.password.status"
				:invalid-feedback="user.password.invalidMessage"
			>
			<b-input-group>
			<b-form-input
				v-model="user.password.value"
				id="password"
				:strength="passwordStrength"
				:type="passwordFieldType"
				@input="updatePasswordStrength"
				autocomplete="off"
			/>
			<b-input-group-append>
			<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
			</b-input-group-append>
			</b-input-group>
			</b-form-group>
		</b-col>
	</b-row>

<b-row>
	<b-col>
		<b-button variant="primary" type="button" @click="onSubmit">Set Password <b-spinner small label="Saving..." class="ml-2" v-if="saving" /></b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

</b-form>
</div>

</b-container>
</template>


<script>
import ResetPasswordToken from '../models/ResetPasswordToken';
// import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
// import Treeselect from '@riophae/vue-treeselect'
// import { VuePassword } from '../components/vue-password'
// import Format from '../utility/Format';
import User from '../models/User';

import Vue from 'vue'
// import { mapGetters } from 'vuex';
// import { mapActions } from 'vuex';
// import { mapMutations } from 'vuex';
import BrandingHeading from '../components/BrandingHeading';



export default {
  name: 'AddUser',
  docTitle: "Reset Password - Lane Closures",

  components: {
  	BrandingHeading
	// Treeselect,
// Autocomplete,
// VuePassword
  },
  props: ['jwt'],
  data() {
	return {
		passwordFieldType: "password",
		ResetPasswordToken,
		user: null,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		selectSupervisor:new BootstrapField({
					value: null,
		}),
		selectAlternate:new BootstrapField({
					value: null,
		}),
		selectAway:new BootstrapField({
					value: null,
		}),
		showRequiredFieldModal: false,
		requesterProjectIdOptions: [],
		supervisorInfo: null,
		alternateInfo: null,
		awayInfo: null,
		refSearchSupervisor: null,
		refSearchAlternate: null,
		refSearchAway: null,
		show: true,
		status:null,
		submissionStatus: null,
		showNewOrganizationModal: false,
		organizationInfo:null,
		passwordStrength:0,
		confirmPasswordStrength:0,
		usernamePrefix:new BootstrapField({
					value: null}),
		saving: false,
	}
	},
	mounted() {
		this.GetResetPasswordInfo();
   },
	computed: {
		organizationSuffix: function() {
			if (this.user) {
				if (this.user.domain.value) {
					return this.user.domain.value;
				}
			}

			return null
		}
	},

	watch: {
		'user.organizationId.value':function() {
			this.calculateUserName();
		},
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'user.phone.value':function() {
		}
	},

  methods: {
  	switchPasswordVisibility() {
  	  this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  	},


	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},

	calculateUserName() {
		if (this.user) {
			if (this.usernamePrefix.value) {
				this.user.username.value = this.usernamePrefix.value + this.user.domain.value;
			} else {
				this.user.username.value = null;
			}
		} else {
			this.user.username.value = null;
		}
		// TODO: confirm that user name is not taken.
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		goToHome() {
			this.$router.push('/')
		},
		onSubmit(evt) {
			evt.preventDefault()
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.PostPassword(that.user);
			});
		},
		onReset(evt) {
			evt.preventDefault()
			// Trick to reset/clear native browser form validation state
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		PostPassword(t) {
			this.saving = true;
			if (t instanceof ResetPasswordToken) {
				// TODO: Do we clear the first cross street and last cross street?
				// fill the first cross and last cross street names...
				Vue.prototype.$http.post(this.$store.state.apiUrl + '/user/reset-password', t.getRawValue())
					.then(resp => {
						// Handle Success
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.saving = false;
						this.SaveNewSuccess();
						this.onSubmitPromiseDeferred.resolve();
					})
					.catch(error => {
						this.saving = false;

						if (error) {
							this.saveState = 'fail';
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								// this.user.SetErrors(error.response.data);
								this.showErrors(error.response.data.fields);
							} else {
								ErrorHandler.RedirectToLogin();
							}
							this.onSubmitPromiseDeferred.reject();
						}
					}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		SaveExistingSuccess() {
			// TODO: Show thank you message?
			// this.user.SetErrors({});
		},

		SaveNewSuccess() {
			// TODO: Show thank you message?
			// this.user.SetErrors({});
			// Start a new lane closure request?
		},

		validateFields() {

			this.user.validate();
			this.agreeResponsibilities.validate();
			this.enablePerIntersectionRestriction.validate();

			return true;
		},

			// Loads user data into the component based on provided id.
			GetResetPasswordInfo() {
				if (this.jwt) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/user/reset-password-info/?jwt=" + this.jwt + "&r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.user = new ResetPasswordToken(response.data);
						this.loaded = true;
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}
			},
		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		}
	}, // end of methods();
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>